import { render, staticRenderFns } from "./VersionHistoryDetails.vue?vue&type=template&id=647c4b0a&scoped=true&"
import script from "./VersionHistoryDetails.vue?vue&type=script&lang=ts&"
export * from "./VersionHistoryDetails.vue?vue&type=script&lang=ts&"
import style0 from "./VersionHistoryDetails.vue?vue&type=style&index=0&id=647c4b0a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647c4b0a",
  null
  
)

export default component.exports